namespace RioERP.Masters {
    export interface PendriveTypesForm {
        PendriveType: Serenity.StringEditor;
    }

    export class PendriveTypesForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.PendriveTypes';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PendriveTypesForm.init)  {
                PendriveTypesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PendriveTypesForm, [
                    'PendriveType', w0
                ]);
            }
        }
    }
}
